export const invoicesTranslation = {
  title: 'invoices.pageTitle',
  toolbar: {
    itemsSelected: 'invoices.toolbar.itemsSelected',
    downloadInvoices: 'invoices.toolbar.downloadInvoices',
    downloadTransactions: 'invoices.toolbar.downloadTransactions',
    transactionsDefaultName: 'invoices.toolbar.transactionsDefaultName',
  },
  table: {
    title: 'invoices.table.title',
    noInvoices: 'invoices.table.noInvoices',
    filters: {
      beginDate: 'invoices.table.filters.beginDate',
      endDate: 'invoices.table.filters.endDate',
      status: 'invoices.table.filters.status',
      statusPlaceholder: 'invoices.table.filters.statusPlaceholder',
      searchPlaceholder: 'invoices.table.filters.searchPlaceholder',
    },
    header: {
      title: 'invoices.table.header.title',
      creationDate: 'invoices.table.header.creationDate',
      local: 'invoices.table.header.local',
      nursery: 'invoices.table.header.nursery',
      number: 'invoices.table.header.number',
      status: 'invoices.table.header.status',
      reimburcementDates: 'invoices.table.header.reimburcementDates',
      reimburcementQuantity: 'invoices.table.header.reimburcementQuantity',
      nAsignaciones: 'invoices.table.header.numeroAsignaciones',
      nTransacciones: 'invoices.table.header.numeroTransacciones',
      reimburcementAmount: 'invoices.table.header.reimburcementAmount',
      totalAmount: 'invoices.table.header.totalAmount',
      actions: 'invoices.table.header.actions',
    },
    body: {
      state: {
        paid: 'invoices.table.body.state.paid',
        pending: 'invoices.table.body.state.pending',
      },
      tooltips: {
        notReadyDownload: 'invoices.table.body.tooltips.notReadyDownload',
        notReadyTransactions: 'invoices.table.body.tooltips.notReadyTransactions',
        notDownloadable: 'invoices.table.body.tooltips.notDownloadable',
      },
      actions: {
        downloadInvoice: 'invoices.table.body.actions.downloadInvoice',
        downloadTransactions: 'invoices.table.body.actions.downloadTransactions',
      },
    },
  },
}
